export const LEFT = 37;
export const UP = 38;
export const RIGHT = 39;
export const DOWN = 40;
export const ENTER = 13;
export const SPACE = 32;
export const ESC = 27;
export const TAB = 9;



// WEBPACK FOOTER //
// ./src/keys.js